import styled from "styled-components";

export const StyledBoard = styled.table`
    align-self: center;
    margin: 0 2rem;
`;